import { Provider } from '@angular/core';
import { ProductTypes, standardItemConverter, standardItemPricingConverter, standardProductDetailsConverter } from 'products-data';
import { provideItemResultComponent } from '../../item';
import { CommonItemResultLayoutComponentsProviderComponent } from '../../item/types/common/common-item-result-layout-components-provider/common-item-result-layout-components-provider.component';
import { StandardItemResultLayoutComponentsProviderComponent } from '../../item/types/standard/component-providers/standard-item-result-layout-components-provider/standard-item-result-layout-components-provider.component';
import { provideProductDetailsComponent } from '../layouts';
import { CommonProductDetailLayoutComponentsProviderComponent } from '../types/common/component-provider';
import { StandardProductDetailLayoutComponentsProviderComponent } from '../types/standard/component-provider/standard-product-detail-layout-components-provider';
import { StandardProductResultLayoutComponentsProviderComponent } from '../types/standard/component-provider/standard-product-result-layout-components-provider';
import { provideProductType } from './provideProductType';

export function provideStandardProductType(): Provider[] {
  return [
    provideProductDetailsComponent({
      type: ProductTypes.Standard,
      component: CommonProductDetailLayoutComponentsProviderComponent,
    }),
    provideItemResultComponent({
      type: ProductTypes.Standard,
      component: CommonItemResultLayoutComponentsProviderComponent,
    }),
    ...provideProductType(ProductTypes.Standard, {
      productResultComponent: StandardProductResultLayoutComponentsProviderComponent,
      productDetailComponent: StandardProductDetailLayoutComponentsProviderComponent,
      itemResultComponent: StandardItemResultLayoutComponentsProviderComponent,
      productDetailsConverter: standardProductDetailsConverter,
      itemConverter: standardItemConverter,
      pricingConverter: standardItemPricingConverter,
    }),
  ];
}
